export default {
	setUserInfo({commit}, payload) {
		commit("SET_USERINFO", payload);
	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js